{
  "breadcrumbs": {
    "customers": {
      "index": "$t(common:labels.customers)",
      "detail": "$t(common:labels.customerDetails)",
      "accounts": {
        "detail": "Account Details",
        "editAuthorization": "$t(customerAccount:labels.editAuthorization)",
        "transactions": {
          "detail": "$t(common:labels.transactionDetails)"
        },
        "newInstrument": "$t(customerAccount:labels.newInstrument)",
        "instruments": {
          "detail": "Instrument Details"
        },
        "addAccount": "Add Account"
      }
    },
    "accountHolder": {
      "index": "$t(customerAccount:labels.accountHolder)",
      "add": "$t(common:components:buttons:add)"
    }
  },
  "labels": {
    "newInstrument": "New Instrument",
    "editAuthorization": "Edit Authorization",
    "communication": "Communication",
    "collectionRecoveries": "Collection & Recoveries",
    "transactionTypes": {
      "ACCOUNT_INQUIRY": "Account Inquiry",
      "FUNDING": "Funding",
      "PAYMENT": "Payment",
      "PIN_CHANGE": "Pin Change",
      "PIN_UNBLOCK": "Pin Unblock",
      "SPEND": "Spend",
      "TRANSFER": "Transfer",
      "TYPE_UNSPECIFIED": "Type Unspecified",
      "CARD_SPEND": "Card Spend"
    },
    "availableCredit": "Available Credit",
    "balanceAfterAdjustment": "Balance After Adjustment",
    "account": "Account",
    "transactionType": "$t(common:labels.transactionType)",
    "phoneNumber": "Phone Number/Mobile Number",
    "customerNameWithParam": "$t(customerAccount:labels.customerName): {{name}}",
    "customerId": "Customer Id",
    "accountType": "Account Type",
    "postcode": "Postcode",
    "accountHolderDetails": "Account Holder Details",
    "accountHolder": "Account Holder",
    "postbox": "Postbox",
    "cardDelivery": "Card Delivery",
    "selectCountry": "Select country",
    "accountUserDetails": "Account User Details",
    "addAccountUsers": "Add Account Users",
    "contactFirstName": "Contact First Name",
    "contactLastName": "Contact Last Name",
    "availableCreditLimit": "Available Credit Limit",
    "totalCreditLimit": "Total Credit Limit",
    "accountInfo": "Account Info",
    "productInfo": "Product Info",
    "previousBalance": "Previous Balance",
    "endingBalance": "Ending Balance",
    "totalInterest": "Total Interest",
    "feesBilled": "Fees Billed",
    "interestByBucket": "Interest By Bucket",
    "personalEmail": "Personal Email",
    "addressFields": {
      "mainAddressLine1": "Main Address Line 1",
      "mainAddressLine2": "Main Address Line 2"
    },
    "editContactInformation": "Edit Contact Information",
    "editContact": "Edit Contact",
    "markAsDeceased": "Mark as Deceased",
    "ledgerName": "$t(common:labels.ledgerName)",
    "ledgerCurrency": "Ledger Currency",
    "accountTypeHeader": "Account type: ",
    "accountIdHeader": "Account ID: ",
    "accountHeader": "Account: ",
    "ledgerTypeHeader": "Ledger type: ",
    "ledgerIdHeader": "Ledger ID: ",
    "ledgerHeader": "Ledger: ",
    "ledgerStatusUnspecified": "Ledger Status Unspecified",
    "activeCards": "Active Cards",
    "fxFees": "FX Fees",
    "billingLedger": "Billing Ledger",
    "newLedger": "New Ledger",
    "addNewLedger": "Add New Ledger",
    "ledgerStatus": "Ledger Status",
    "ledgerType": "Ledger Type",
    "notesPlaceholder": "Your message",
    "reviewStepHeader": "Review Details and add any relevant notes",
    "managePot": "Manage Pot",
    "manageAccount": "Manage Account",
    "preSelected": "Pre-selected",
    "addFunds": "Add funds",
    "withdrawFunds": "Withdraw funds"
  },
  "errors": {
    "generic": "error",
    "somethingWentWrong": "Something went wrong.",
    "invalidFields": "You have invalid fields. Please input valid data.",
    "transactionFailed": "Transaction Failed",
    "failedToUpload": "Upload failed",
    "updateContactDetailsFailed": "Failed to update contact details.",
    "updateSCRADetailsFailed": "Update SCRA Details Failed",
    "createSCRADetailsFailed": "Create SCRA Details Failed",
    "revokeSCRADetailsFailed": "Revoke SCRA Details Failed",
    "updateDeceasedDetailsFailed": "Update Deceased Details Failed",
    "createDeceasedDetailsFailed": "Mark as Deceased Failed",
    "revokeDeceasedDetailsFailed": "Revoke Deceased Status Failed",
    "fetchAccountOptionsFailed": "Could not load the account options. Please try again."
  },
  "components": {
    "accountBalance": {
      "messages": {
        "accountOverlimit": "Account is Overlimit",
        "accountCreditBalance": "Account has a Credit Balance",
        "accountNoAvailableCredit": "Account has no Available Credit",
        "accountNoCreditLimit": "Account has no Credit Limit"
      }
    },
    "customerDetails": {
      "cumulativeBalance": "Cumulative Balance",
      "cardDeliveryAddress": "Card Delivery Address",
      "downloadAttachment": "Download Attachment"
    },
    "accountsTable": {
      "accountIdSearch": "Search Account ID",
      "exchangeRate": "Exchange Rate"
    },
    "creditDetailsInformation": {
      "creditLimit": "Credit Limit",
      "pricingTier": "Pricing Tier",
      "openDate": "Open Date",
      "firstStatementDate": "First Statement Date",
      "nextDueDate": "Next Due Date",
      "statementDate": "Statement Date"
    },
    "transactionsList": {
      "extendExpiryDate": "Extend Expiry Date",
      "searchTransactionId": "Search Transaction ID",
      "authorizedOn": "Authorised On",
      "messages": {
        "insufficientFunds": "Insufficient funds"
      }
    },
    "transactionDetails": {
      "totalFees": "Total Fees",
      "conversionRate": "Conversion Rate",
      "originalTransactionId": "Original Transaction ID",
      "merchantDetails": "Merchant Details",
      "merchantName": "Merchant Name",
      "cardAndAccountDetails": "Card & Account Details"
    },
    "editAccountHolder": {
      "messages": {
        "successfulUpdateAccountHolder": "You have successfully updated the account information."
      }
    },
    "adjustBalance": {
      "amountYouWantToAdjust": "Amount you want to adjust",
      "transactionReasonCode": "Transaction Reason Code",
      "selectTransactionReasonCode": "Select transaction reason code",
      "selectAdjustmentType": "Select Adjustment Type",
      "selectLedger": "Select a ledger",
      "selectLedgerRequired": "Please select a ledger",
      "noLedgersWarning": "No ledgers found for this account. Please create a ledger before making balance adjustments.",
      "prepositionInto": "into",
      "prepositionFrom": "from",
      "messages": {
        "enterValidAmount": "Please enter a valid adjustment amount",
        "enterValidNotes": "Please enter a valid note",
        "enterValidTransactionReason": "Please enter a valid transaction reason",
        "balanceUpdating": "The ledger balance is being updated",
        "balanceAdjustmentWarningMessage": "You are adjusting an amount of <0>{{amount}}</0> in this account. Please review the transaction and add a reason to proceed",
        "areYouSureYouWantToSaveChanges": "Are you sure you want to {{transactionType}} <0>{{amount}}</0> {{preposition}} your account?"
      }
    },
    "editAuthorization": {
      "selectAuthorizationType": "Select Authorization Type",
      "reverseFullAmount": "Reverse Full Amount",
      "reversePartial": "Reverse Partial",
      "reverseAmount": "Amount you want to reverse",
      "reverseAmountInfo": "Reversal amount should be less than or equal to Billing Amount",
      "messages": {
        "editAuthorizationWarningMessage": "Removing an authorization doesn't prevent the associated presentment from being recieved for this transaction. If a presentment is recieved, Thredd will still process this",
        "editAuthorizationInfoMessage": "You are removing an authorization transaction of <0>{{amount}}</0> <1>{{currency}}</1> from this card. Please review the transaction and add a reason to proceed."
      }
    },
    "accountOperations": {
      "accountOperations": "Account Operations"
    },
    "customerOperations": {
      "customerOperations": "Customer Operations"
    },
    "customerSearch": {
      "recentSearches": "Recent Searches",
      "clearAll": "Clear All",
      "servicing": "Servicing",
      "matchingResults": "Matching Results",
      "accountNumberField": "Account Number",
      "chooseWhatToSearch": "Choose what you want to search",
      "retail": "Retails"
    },
    "companyDetails": {
      "workInformationHeader": "Work Information",
      "parentCompany": "Parent Company",
      "subsidiary": "Subsidiary",
      "department": "$t(common:labels.department)",
      "branchName": "Branch",
      "parentCompanyId": "Parent Company Id",
      "subsidiaryId": "Subsidiary Id",
      "departmentId": "Department Id",
      "branchId": "Branch Id",
      "legalCompanyName": "Legal Company Name",
      "taxId": "Tax Id",
      "companyNumber": "Company Number",
      "lastUpdatedBy": "Last Updated by"
    },
    "createNewAccountHolder": {
      "addNewAccountHolder": "Add New Account Holder",
      "invalidEmail": "Invalid email",
      "postboxAddress": "Postbox Address"
    },
    "createAccount": {
      "addNewAccount": "Create New Account",
      "chooseFinancialProduct": "Choose Financial Product",
      "configureAccount": "Configure Account",
      "bucketInterestConfiguration": "Bucket Interest Configuration",
      "unableToFetchPolicies": "Unable to fetch policies",
      "apr": "APR",
      "aprPerYear": "{{apr}}% / year",
      "dailyRate": "Daily rate",
      "pricingTierTitle": "Pricing Tier: {{tier}}",
      "bucketName": "Bucket Name: {{name}}"
    },
    "addAccount": {
      "issueCard": "Issue a card for this account",
      "successMessage": "Account {{accountId}} was created in {{status}} status."
    },
    "productInfo": {
      "productSummary": "Product Summary",
      "scheme": "Scheme / Network",
      "cardBenefits": "Card Benefits"
    },
    "accountInfo": {
      "accountOverview": "Account Overview",
      "cashLimit": "Cash Limit",
      "cashBalance": "Cash Balance",
      "cashAvailable": "Cash Available",
      "totalOutstandingAuths": "Total Outstanding Auths",
      "overlimitAmount": "Overlimit Amount",
      "amountPastDue": "Amount Past Due",
      "daysPastDue": "Days Past Due",
      "statementSummary": "Statement Summary",
      "cycleDay": "Cycle Day",
      "minimumDueAmount": "Minimum Due Amount",
      "paymentDueDate": "Payment Due Date",
      "lastPaymentAmount": "Last Payment Amount",
      "lastPaymentDate": "Last Payment Date",
      "lastStatementBalance": "Last Statement Balance",
      "autoPayType": "AutoPay Type",
      "nextAutoPayAmount": "Next AutoPay Amount",
      "autoPayDate": "AutoPay Date",
      "autoPayDetails": "AutoPay Details"
    },
    "interestByBuckets": {
      "interestRate": "Interest Rate"
    },
    "notes": {
      "addNewNote": "Add New Note",
      "updateNote": "Update Note",
      "areYouSureYouWantToDelete": "Are you sure you want to delete this note?",
      "uploadAttachment": "Upload Attachment"
    },
    "statements": {
      "heading": "Statements",
      "deliveryChannel": "Statement delivery channel",
      "digitalChannel": "Digital",
      "paperChannel": "Paper",
      "filterByYear": "Filter By Year",
      "selectYear": "Select Year",
      "totalPurchases": "Total Purchases",
      "paymentsReceived": "Payments Received",
      "viewDetail": "View Detail",
      "viewStatement": "View Statement",
      "viewStatementPdf": "View Statement PDF",
      "downloadStatementPdf": "Download Statement PDF"
    },
    "communication": {
      "addFilter": "+ Filter",
      "viewCommunication": "View Communication",
      "viewCommunicationPdf": "View Communication PDF",
      "downloadCommunicationPdf": "Download Communication PDF",
      "requestedBy": "Requested By",
      "empty": "-",
      "pageSize10": "10 / page",
      "pageSize20": "20 / page",
      "pageSize50": "50 / page"
    },
    "pdfViewer": {
      "downloadPdf": "Download PDF",
      "failedToLoad": "Failed to load PDF"
    },
    "statementDetails": {
      "statementDetail": "Statement Detail",
      "cyclePeriodNumber": "Cycle Period Number",
      "balanceDetails": "Balance Details",
      "totalCash": "Total Cash",
      "previousAvailableCredit": "Previous Available Credit",
      "endingAvailableCredit": "Ending Available Credit",
      "cardActDetails": "CARD Act Details",
      "minPaymentOnlyTerms": "Min Payment Only Terms",
      "minPaymentOnlyInterest": "Min Payment Only Interest",
      "minPaymentOnlyPrincipal": "Min Payment Only Principal",
      "36MonthPaymentAmount": "36 Month Payment Amount",
      "36MonthInterest": "36 Month Interest",
      "36MonthPrincipal": "36 Month Principal",
      "noData": "No statement available",
      "months": {
        "nov2025_2": "Nov 2025 (2)",
        "nov2025_1": "Nov 2025 (1)",
        "oct2025": "Oct 2025",
        "sept2025": "Sept 2025"
      }
    },
    "scraDetails": {
      "scraDetailsHeader": "SCRA Details"
    },
    "form": {
      "fields": {
        "scraActiveDutyOrdersReceived": {
          "label": "Active Duty Orders Received",
          "placeholder": "Select date when active duty orders were received",
          "required": "Please select the date when active duty orders were received"
        },
        "scraMilitaryBranch": {
          "label": "Military Branch",
          "placeholder": "Select military branch",
          "required": "Please select the military branch"
        },
        "scraActiveDutyStartDate": {
          "label": "Active Duty Start Date",
          "placeholder": "Select active duty start date",
          "required": "Please select the active duty start date"
        },
        "scraActiveDutyEndDate": {
          "label": "Active Duty End Date",
          "placeholder": "Select active duty end date"
        },
        "scraRequestBenefitsDate": {
          "label": "Request Benefits Date",
          "placeholder": "Select date when benefits were requested"
        },
        "scraVerificationDate": {
          "label": "Verification Date",
          "placeholder": "Select verification date"
        },
        "documents": {
          "label": "Document",
          "placeholder": "Upload supporting documents",
          "uploadText": "Click or drag file to this area to upload",
          "supportedTypes": "Supported Formats: PDF, JPG, PNG | Max Size: 10 MB"
        },
        "notes": {
          "label": "$t(common:labels.notes)",
          "placeholder": "$t(customerAccount:labels.notesPlaceholder)"
        },
        "deleteNotes": {
          "label": "Delete Notes",
          "placeholder": "$t(customerAccount:labels.notesPlaceholder)",
          "required": "Please enter reason for revoking data"
        },
        "editNotes": {
          "label": "Edit Notes",
          "placeholder": "$t(customerAccount:labels.notesPlaceholder)",
          "required": "Please enter reason for editing notes"
        },
        "dateOfDeath": {
          "label": "Date of Death",
          "placeholder": "Select date of death",
          "required": "Please select the date of death"
        },
        "dateDeceasedVerified": {
          "label": "Date Deceased Verified",
          "placeholder": "Select date deceased verified",
          "required": "Please select the date deceased verified"
        },
        "deathMasterId": {
          "label": "Death Master ID",
          "placeholder": "Enter Death Master ID",
          "required": "Please enter the Death Master ID"
        }
      }
    },
    "addEditModal": {
      "addSCRADetails": "Add SCRA Details",
      "editSCRADetails": "Edit SCRA Details",
      "revokeScraDetails": "Revoke SCRA Details",
      "revokeScra": "Revoke SCRA",
      "revokedSCRADetailsSuccessfully": "Removed SCRA successfully",
      "addedSCRADetailsSuccessfully": "SCRA Details added successfully",
      "updatedSCRADetailsSuccessfully": "Update SCRA Details successfully",
      "messages": {
        "enterValidScraActiveDutyOrdersReceived": "Please enter a valid date for Active Duty Orders Received",
        "enterValidScraMilitaryBranch": "Please enter a valid Military Branch",
        "enterValidScraActiveDutyStartDate": "Please enter a valid Active Duty Start Date",
        "enterValidScraActiveDutyEndDate": "Please enter a valid Active Duty End Date",
        "enterValidScraRequestBenefitsDate": "Please enter a valid Request Benefits Date",
        "enterValidScraVerificationDate": "Please enter a valid Verification Date"
      }
    },
    "newLedger": {
      "title": "$t(common:labels.createNewLedger)",
      "steps": {
        "ledgerDetails": "$t(common:labels.ledgerDetails)"
      },
      "messages": {
        "successMessage": "$t(common:labels.ledgerCreatedSuccess)"
      }
    },
    "deceasedDetails": {
      "deceasedDetailsHeader": "Deceased Details"
    },
    "addEditDeceasedModal": {
      "addDeceasedDetails": "$t(customerAccount:labels.markAsDeceased)",
      "editDeceasedDetails": "Edit Deceased Details",
      "revokeDeceasedDetails": "Revoke Deceased Status",
      "revokeDeceasedStatus": "Revoke Deceased",
      "revokedDeceasedDetailsSuccessfully": "Removed deceased status successfully",
      "addedDeceasedDetailsSuccessfully": "Marked as deceased successfully",
      "updatedDeceasedDetailsSuccessfully": "Updated deceased details successfully",
      "messages": {
        "enterValidDateOfDeath": "Please enter a valid date of death",
        "enterValidDateDeceasedVerified": "Please enter a valid date deceased verified",
        "enterValidDeathMasterId": "Please enter a valid Death Master ID"
      }
    },
    "managePot": {
      "selectTransactionPurpose": "Select transaction purpose",
      "enterAmount": "Enter Amount",
      "effectiveDate": "Effective Date",
      "adjustBalance": "Adjust Balance",
      "areYouSureYouWantToAddFundsToThisAccount": "Are you sure you want to add funds to this account?",
      "areYouSureYouWantToWithdrawFundsFromThisAccount": "Are you sure you want to withdraw funds from this account?",
      "areYouSureYouWantToAdjustBalanceForThisAccount": "Are you sure you want to adjust the balance for this account?",
      "apexChannel": "APEX Channel"
    },
    "updateCustomerStatus": {
      "title": "Update Customer Status",
      "description": "Select a new status for this customer. Note that some statuses are permanent and cannot be changed once set.",
      "newStatus": "New Status",
      "selectNewStatus": "Select new status",
      "notes": "$t(common:labels.notes)",
      "notesPlaceholder": "$t(customerAccount:labels.notesPlaceholder)",
      "successToast": "Customer status updated successfully",
      "failedToast": "Failed to update customer status"
    },
    "updateAccountStatus": {
      "title": "Update Account Status",
      "description": "Select a new status for this account. Note that some statuses are permanent and cannot be changed once set.",
      "successToast": "Account status updated successfully",
      "failedToast": "Failed to update account status"
    }
  }
}
